import owlWaveUrl from '../../../assets/brand/owl-wave.webp';

/**
 * Zé Coruja for the feedback tab's empty state — DESIGN_SYSTEM.md §4.8 ("空
 * 态：Coruja 表情 + 一句白话 + 一个 CTA") and §6 (whitelist: empty states;
 * forbidden: beside a primary CTA, compliance copy, wallet amounts, or an
 * error/lock state — so this file has exactly one export, used in exactly
 * one place, and FeedbackPanel's error state keeps its plain AlertTriangle
 * icon rather than borrowing this).
 *
 * `owl-wave.webp` is cropped from the shared brand sheet
 * (doc/brand/assets/owl-expressions.png, leftmost pose) the same way
 * BrandOwl's owl-mark.webp was cut from the master art: source alpha kept
 * as-is (already transparent, no background to key out), resized once at
 * build time so the shipped asset is a few KB instead of the ~900KB source.
 *
 * Natural size is 112×128 (taller than wide, ratio 0.875). §6's 20-48px band
 * is a bounding box, the same convention BrandOwl's single `size` prop uses
 * — so both dimensions must clear 48px, not just width. 48×55 (width-only
 * constrain) blew the height by 15%; 42×48 fits the box on the constraining
 * (taller) axis with the source ratio untouched, no distortion.
 */
export function FeedbackEmptyOwl() {
  return (
    <img
      src={owlWaveUrl}
      alt=""
      width={42}
      height={48}
      className="feedback-empty-owl"
      draggable={false}
    />
  );
}
